import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Bibo Activations")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "BIBO Code"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Endorser's Fullname"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Activation Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Action")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisterEndorserModalBibo = _resolveComponent("RegisterEndorserModalBibo")
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("table", _hoisted_5, [
            _hoisted_6,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, _toDisplayString(index+1), 1),
                  _createVNode("td", null, _toDisplayString(item.bibocode), 1),
                  _createVNode("td", null, _toDisplayString(item.endorser_fullname), 1),
                  (item.endorser_cifid == 0 )
                    ? (_openBlock(), _createBlock("td", _hoisted_7))
                    : _createCommentVNode("", true),
                  (item.endorser_cifid != 0 )
                    ? (_openBlock(), _createBlock("td", _hoisted_8, _toDisplayString(item.activation_date), 1))
                    : _createCommentVNode("", true),
                  (item.endorser_cifid == 0 )
                    ? (_openBlock(), _createBlock("td", _hoisted_9, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-success px-2 py-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": `#kt_register_endorser_modal_bibo`,
                          onClick: ($event: any) => {_ctx.showEndorserRegistrationModal(item.bibo_codeid);}
                        }, " Activate ", 8, ["onClick"]),
                        _createVNode(_component_RegisterEndorserModalBibo, {
                          "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8",
                          bibo_codeid: _ctx.bibo_codeid
                        }, null, 8, ["bibo_codeid"])
                      ]))
                    : _createCommentVNode("", true),
                  (item.endorser_cifid != 0 )
                    ? (_openBlock(), _createBlock("td", _hoisted_10))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_pagination, {
        pagination: _ctx.pagination,
        callback: _ctx.reorderhistory,
        options: _ctx.paginationOptions
      }, null, 8, ["pagination", "callback", "options"])
    ], 2)
  ]))
}